import type { FC } from 'react';
import React from 'react';
import { Helmet } from 'react-helmet';
import {
  Box,
  Container,
  Grid,
  Typography
} from '@mui/material';
import AppBar from '../components/AppBar';
import ProjectCard from '../components/ProjectCard';
import Link from '../components/Link';

const About: FC = () => {
  return (
    <Box>
      <Helmet title="About Us | Scawwy Howwow Theatre, Inc" />
      <AppBar />
      <Container
        maxWidth="xl"
        sx={{ my: 6 }}
      >
        <Typography variant="h1">
          About Scawwy Howwow
        </Typography>
        <Typography color="textSecondary">
          Inspired by the theatre manifesto of Antonin Artaud, Scawwy Howwow Theatre aims to push the limits
          of theatre, media, and horror. From new formats to new mediums to new voices, we aim to bring a
          whole new experience to the world. For inquiries, reach us at{' '}
          <Link href="mailto:scawwyhowwowtheatre@gmail.com">scawwyhowwowtheatre@gmail.com</Link>.
        </Typography>
        <Typography variant="h1" sx={{ pt: 3 }}>
          The Team
        </Typography>
        <Grid container spacing={3} sx={{ mb: 6 }}>
          <Grid item xs={12} sm={6} lg={3}>
            <ProjectCard title="Nicholas Tran" body="Executive Director" src="/static/nicholas.jpg"/>
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <ProjectCard title="Daniel Moore" body="Creative Director"
              src="/static/daniel.jpg" href="https://danielmoore.work"/>
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <ProjectCard title="Subin Kara Ahn" body="Artistic Director"
              src="/static/subin.jpg" href="https://www.subinkaraahn.com/"/>
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <ProjectCard title="Claire Simmonds" body="Visual Arts Director"
              src="/static/claire.jpg" href="https://www.eclaire.site/"/>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default About;
